

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"8.842","height":"12"}, rest), [h('path', {"fill":"#041E49","fill-rule":"nonzero","d":"M4.421 7.216c-.453 0-.832-.163-1.137-.488a1.67 1.67 0 0 1-.458-1.186V1.58c0-.439.155-.811.465-1.118C3.601.154 3.977 0 4.421 0c.442 0 .818.154 1.129.46.31.308.466.68.466 1.119v3.963c0 .465-.153.86-.458 1.186a1.495 1.495 0 0 1-1.137.488ZM3.947 12V9.853a4.31 4.31 0 0 1-2.81-1.406A4.142 4.142 0 0 1 0 5.542h.947c0 .958.339 1.763 1.015 2.416.677.653 1.496.979 2.456.979s1.78-.326 2.458-.98c.68-.652 1.019-1.457 1.019-2.415h.947a4.142 4.142 0 0 1-1.137 2.905 4.31 4.31 0 0 1-2.81 1.406V12h-.948Z"}, [])]);
};

        